import { get } from "../config/api";

export interface Signature {
  name: string;
  date: string | null;
}

export interface ResponseValidarDocumento {
  date: string;
  control_code: string;
  filename: string;
  signatures: Signature[];
}

export default class DocumentoAssinadoService {
  public static async validar(codigo: string) {
    return get<ResponseValidarDocumento>(`/documento_assinado/${codigo}/validar`)
      .then((response) => response);
  }
}
